import { toast } from 'react-toastify';
import { Api } from '../lib/api/api';
import { ERROR_MESSAGE } from '../lib/constants';
import { checkIfIsBoxTab } from './EpikBoxes';

export const setActiveProvisionTab = tab => dispatch => {
  dispatch({
    type: 'SET_ACTIVE_PROVISIONING_TAB',
    tab,
  });
};

export const selectedNumbers = telephoneNumber => dispatch => {
  dispatch({
    type: 'SELECTED_NUMBER',
    telephoneNumber,
  });
};

export const resetSelectedNumbers = telephoneNumber => dispatch => {
  dispatch({
    type: 'RESET_SELECTED_NUMBER',
    telephoneNumber,
  });
};

export const clearSearchedNumbers = () => dispatch => {
  dispatch({
    type: 'CLEAR_SEARCH_NUMBER',
  });
};

export const searchNumber = (token, body, provider) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'SEARCH_NUMBER',
  });
  try {
    var searchedNumbers = await api.provision.searchNumber(body, provider);
    if (searchedNumbers.tnResult.length === 0) {
      toast.error('No Number Found');
    }
    dispatch({
      type: 'SEARCH_NUMBER_SUCCESS',
      searchedNumbers,
    });
  } catch (error) {
    dispatch({
      type: 'SEARCH_NUMBER_ERROR',
      error,
    });
    toast.error(error.response.data);
  }
};

export const getGateways = token => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_GATEWAYS',
  });
  try {
    var gateways = await api.provision.getGateways();
    dispatch({
      type: 'GET_GATEWAYS_SUCCESS',
      gateways,
    });
  } catch (error) {
    dispatch({
      type: 'GET_GATEWAYS_ERROR',
      error,
    });
  }
};

export const assignRouteInfo = (token, id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ASSIGN_ROUTE',
    id: id,
  });
  try {
    const route = await api.provision.assignRouteInfo(id);
    dispatch({
      type: 'ASSIGN_ROUTE_SUCCESS',
      route
    });
    // toast.success('Number route updated');
    return true;
  } catch (error) {
    dispatch({
      type: 'ASSIGN_ROUTE_ERROR',
      error,
    });
    toast.error(error.response.data);
  }
};

export const queryLrn = (token, id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'QUERY_LRN',
    id,
  });
  dispatch({
    type: 'QUERY_LRN_SUCCESS',
    queryLrn: null,
  });
  try {
    const queryLrnInfo = await api.provision.queryLrn(id);
    dispatch({
      type: 'QUERY_LRN_SUCCESS',
      queryLrn: queryLrnInfo,
    });
    return true;
  } catch (error) {
    dispatch({
      type: 'QUERY_LRN_ERROR',
      error,
    });
  }
};

export const lrnInfoByNumber = (token, id, lrnRoute) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'QUERY_LRN',
    id,
  });
  dispatch({
    type: 'QUERY_LRN_SUCCESS',
    queryLrn: null,
  });
  try {
    const queryLrnInfo = await api.provision.lrnInfoByNumber(id, lrnRoute);
    dispatch({
      type: 'QUERY_LRN_SUCCESS',
      queryLrn: queryLrnInfo,
    });
    return true;
  } catch (error) {
    // dispatch({
    //   type: 'QUERY_LRN_ERROR',
    //   error,
    // });
    toast.error(error.response.data);
    dispatch(hideQueryLrnModalFn());
  }
};

export const getAddress = (token, numId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_ADDRESS',
  });
  try {
    var address = await api.provision.getAddress(numId);
    dispatch({
      type: 'GET_ADDRESS_SUCCESS',
      address,
    });
    return address;
  } catch (error) {
    if (error?.response?.status === 500) {
      toast.error(`${error?.response?.statusText} on fetching e911 number request, please contact support.`)
    } else {
      toast.error(`${error?.response?.data}`)
    }
    dispatch({
      type: 'GET_ADDRESS_ERROR',
      error,
    });
  }
};

export const getNumberOrderList = (token, numId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_ORDER_HISTORY',
  });
  const loading = toast.info('Loading...', { toastId: 'loading', autoClose: false });
  let result = [];
  try {
    result = await api.provision.getNumberOrderList(numId);
    dispatch({
      type: 'GET_ORDER_HISTORY_SUCCESS',
    });
  } catch (error) {
    dispatch({
      type: 'GET_ORDER_HISTORY_ERROR',
      error,
    });
  }
  toast.dismiss(loading);
  return result;
};

export const updateAddress = (token, numId, body) => async dispatch => {
  const api = new Api(token);
  const loading = toast.info('Updating Address!', { autoClose: false });
  dispatch({
    type: 'UPDATE_ADDRESS',
  });
  try {
    const address = await api.provision.updateAddress(numId, checkIfIsBoxTab(body));
    dispatch({
      type: 'UPDATE_ADDRESS_SUCCESS',
      address,
    });
    toast.success('Address Updated Successfully');
    dispatch({
      type: 'HIDE_E991MODAL',
    });
    dispatch({
      type: 'CLEAR_ADDRESS',
    });
    toast.dismiss(loading);
    return address;
  } catch (error) {
    const ERROR_MESSAGE = 'Something went wrong, Try different address.';
    dispatch({
      type: 'UPDATE_ADDRESS_ERROR',
      error,
    });
    toast.error(error?.response?.data || ERROR_MESSAGE);
    setTimeout(() => {
      toast.dismiss(loading);
    }, 1000)
    return false;
  }
};

export const clearAddress = () => async dispatch => {
  dispatch({
    type: 'CLEAR_ADDRESS',
  });
};

export const removeNumberAddress = (token, id, body) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'REMOVE_NUMBER_ADDRESS',
  });
  try {
    const removeAddress = await api.provision.removeNumberAddress(id, checkIfIsBoxTab(body));
    dispatch({
      type: 'REMOVE_NUMBER_ADDRESS_SUCCESS',
      removeAddress,
    });
    toast.success('Address Removed Successfully!');
    dispatch({
      type: 'HIDE_E991MODAL',
    });
    dispatch(clearAddress());
    return removeAddress;
  } catch (error) {
    dispatch({
      type: 'REMOVE_NUMBER_ADDRESS_ERROR',
      error,
    });
    toast.error(error?.response?.data || ERROR_MESSAGE);
  }
};

export const updateNumberRoute = (token, numId, body) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_NUMBER_ROUTE',
  });
  try {
    const address = await api.provision.updateNumberRoute(numId, checkIfIsBoxTab(body));
    dispatch({
      type: 'UPDATE_NUMBER_ROUTE_SUCCESS',
      address,
    });
    toast.success('Route Updated Successfully');
    return true;
  } catch (error) {
    dispatch({
      type: 'UPDATE_NUMBER_ROUTE_ERROR',
      error,
    });
    toast.error(error?.response?.data || 'Error Updating Route');
  }
};

export const showE911AddressModal = () => dispatch => {
  dispatch({
    type: 'SHOW_E991MODAL',
  });
};

export const hideE911AddressModal = () => dispatch => {
  dispatch({
    type: 'HIDE_E991MODAL',
  });
  dispatch({
    type: 'CLEAR_ADDRESS',
  });
};

export const showQueryLrnModalFn = () => dispatch => {
  dispatch({
    type: 'SHOW_QUERY_LRN_MODAL',
  });
};

export const hideQueryLrnModalFn = () => dispatch => {
  dispatch({
    type: 'HIDE_QUERY_LRN_MODAL',
  });
  dispatch({
    type: 'CLEAR_QUERY_LRN_MODAL',
  });
};

export const getNumberCompanyEmails = (
  token,
  id,
  uid,
  type,
  gflag,
  companyName,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'NUMBER_COMPANY_EMAILS',
  });
  try {
    const emails = await api.numbers.getCompanyNumbers(id, uid, type, gflag);
    dispatch({
      type: 'NUMBER_COMPANY_EMAILS_SUCCESS',
      emails,
      companyName,
    });
  } catch (error) {
    return dispatch({
      type: 'NUMBER_COMPANY_EMAILS_ERROR',
      error,
    });
  }
};

export const orderNumber = (token, body) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ORDER_NUMBER',
  });
  try {
    await api.provision.orderNumber(checkIfIsBoxTab(body));
    dispatch({
      type: 'ORDER_NUMBER_SUCCESS',
    });
    toast.success('Number Ordered Successfully');
    return true;
  } catch (error) {
    dispatch({
      type: 'ORDER_NUMBER_ERROR',
      error,
    });
    toast.error(error?.response?.data || ERROR_MESSAGE);
    return false;
  }
};

export const newNumberOrderList = (token, queryOptions) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.provision.getNewNumberOrderHistory(queryOptions);
    return data;
  } catch (error) {
    console.log(error);
    dispatch({
      type: 'ERROR_GETTING_ORDER_LIST',
    });
    toast.error(error.response.data || ERROR_MESSAGE);
    return { docs: [] };
  }
};
